import { render } from "./McSetPassword.vue?vue&type=template&id=ae74435a&scoped=true"
import script from "./McSetPassword.vue?vue&type=script&lang=js"
export * from "./McSetPassword.vue?vue&type=script&lang=js"

import "./McSetPassword.vue?vue&type=style&index=0&id=ae74435a&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae74435a"]])

export default __exports__